import { CloseSidebarButton } from './close-sidebar-button';
import { OpenSidebarButton } from './open-sidebar-button';

interface SidebarButtonsProps {
  sidebarIsOpen: boolean;
}

export function SidebarButtons({ sidebarIsOpen }: SidebarButtonsProps) {
  return sidebarIsOpen ? <CloseSidebarButton /> : <OpenSidebarButton />;
}
